import resultReader from '../../store/readHelpers/ResultReader';
import sessionReader from '../../store/readHelpers/SessionReader';
import settingsReader from '../../store/readHelpers/SettingsReader';

const allViewContainerSelector = {
    selectShouldRenderAnswerKeys() {
        return sessionReader.isPrintStyleAnswerKeys();
    },

    selectShouldRenderTestCover(shouldRenderAnswerKeys) {
        return !shouldRenderAnswerKeys && (sessionReader.isContextViewOwnDelivery()
            || (sessionReader.isContextViewDelivery() && sessionReader.getPrintParam(sessionReader.printParamNames.SHOW_COVER, true)));
    },

    selectShouldRenderResultPageContainer(shouldRenderAnswerKeys) {
        return !shouldRenderAnswerKeys && sessionReader.isContextViewOwnDelivery();
    },

    selectShouldRenderTableOfContents(shouldRenderAnswerKeys, shouldRenderResultPageContainer) {
        return !shouldRenderAnswerKeys && !shouldRenderResultPageContainer && settingsReader.showTableOfContents();
    },

    selectExtraClasses() {
        const classList = [];
        if (settingsReader.hasSettingValue(sessionReader.printParamNames.INSERT_PAGE_BREAK_BEFORE_QUESTION, true)) {
            classList.push('with-page-break');
        }

        if (sessionReader.isViewMediaPrint()) {
            classList.push('with-page-like-layout');
        }

        if ((sessionReader.isViewMediaPrint() && resultReader.hasExclusiveExternalDelivery())
            || settingsReader.hasSettingValue(sessionReader.printParamNames.EXCLUDE_PDF, true)) {
            classList.push('with-disabled-layout');
        }

        return classList.length > 0 ? classList.join(' ') : '';
    },

    selectProps({ deliveryDetails, toc }) {
        const shouldRenderAnswerKeys = this.selectShouldRenderAnswerKeys();
        const shouldRenderResultPageContainer = this.selectShouldRenderResultPageContainer(shouldRenderAnswerKeys);

        return {
            deliveryDetails,
            itemsOrder: toc.itemsOrderAllView,
            shouldRenderAnswerKeys,
            shouldRenderTestItems: !shouldRenderAnswerKeys,
            shouldRenderTestCover: this.selectShouldRenderTestCover(shouldRenderAnswerKeys),
            shouldRenderResultPageContainer,
            shouldRenderTableOfContents: this.selectShouldRenderTableOfContents(shouldRenderAnswerKeys,
                shouldRenderResultPageContainer),
            extraClasses: this.selectExtraClasses(),
        };
    },
};

export default allViewContainerSelector;
